import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { helpers } from '@minecraft.utils';
import { DrawerProps } from './shared/types';
import { useDrawerContext } from './shared/context';
import DrawerContent from './DrawerContent';

const { changeBodyOverflow } = helpers;

const DrawerContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  font-size: 1rem;
  position: fixed;
  left: 0;
  top: 0;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  z-index: 9999;
`;

const Drawer: FC<DrawerProps> = ({
  title,
  cancelLabel,
  submitLabel,
  cancelClick,
  submitClick,
  renderAdditionalNavigationControls,
  children,
  testId,
}) => {
  const { isDrawerOpened, resetDrawerContext } = useDrawerContext();

  useEffect(() => {
    changeBodyOverflow(isDrawerOpened ? 'hidden' : 'auto');

    return (): void => {
      changeBodyOverflow('auto');
      resetDrawerContext();
    };
  }, [isDrawerOpened]);

  return (
    isDrawerOpened && (
      <DrawerContainer data-testid={testId || 'drawer-container'}>
        <DrawerContent
          title={title}
          cancelLabel={cancelLabel}
          submitLabel={submitLabel}
          cancelClick={cancelClick}
          submitClick={submitClick}
          renderAdditionalNavigationControls={renderAdditionalNavigationControls}
        >
          {children}
        </DrawerContent>
      </DrawerContainer>
    )
  );
};

export default Drawer;
